import { Action } from 'redux';

export const GET_DUPLICATE_LICENSE_REPORT = 'reports-account/GET_DUPLICATE_LICENSE_REPORT';
export const getDuplicateLicenseReport = (data: string) => ({
  type: GET_DUPLICATE_LICENSE_REPORT,
  payload: data,
});

export const SET_DUPLICATE_LICENSE_REPORT = 'reports-account/SET_DUPLICATE_LICENSE_REPORT';
export const setDuplicateLicenseReport = (data: ReadonlyArray<ReportAccountTable>) => {
  return {
    type: SET_DUPLICATE_LICENSE_REPORT,
    payload: data,
  };
};

// bulk report account start

export const GET_BULK_ACCOUNT_REPORT = 'reports-account/GET_BULK_ACCOUNT_REPORT';
export const getBulkAccount = (data: any) => {
  return {
    type: GET_BULK_ACCOUNT_REPORT,
    payload: data,
  };
};

export const SET_BULK_ACCOUNT_REPORT = 'reports-account/SET_BULK_ACCOUNT_REPORT';
export const setBulkAccount = (data: any) => {
  return {
    type: SET_BULK_ACCOUNT_REPORT,
    payload: data,
  };
};

export interface SetBulkDriverAccount extends Action<typeof SET_BULK_ACCOUNT_REPORT> {
  readonly payload: ReadonlyArray<any>;
}

// bulk report account end
export interface SetDuplicateLicenseReport extends Action<typeof SET_DUPLICATE_LICENSE_REPORT> {
  readonly payload: ReadonlyArray<ReportAccountTable>;
}
// Get User Name
export const GET_ALL_USER_NAME = 'reports-account/GET_ALL_USER_NAME';
export const getAllUserName = (data: string) => ({
  type: GET_ALL_USER_NAME,
  payload: data,
});

export const SET_ALL_USER_NAME = 'reports-account/SET_ALL_USER_NAME';
export const setAllUserName = (data: ReadonlyArray<any>) => {
  return {
    type: SET_ALL_USER_NAME,
    payload: data,
  };
};

export interface SetAllUserNameReport extends Action<typeof SET_ALL_USER_NAME> {
  readonly payload: ReadonlyArray<any>;
}
// Get User Name End
// vip report start
export const GET_VIP_LOOKUP = 'reports-account/GET_VIP_LOOKUP';
export const getVipLookup = (data: string) => ({
  type: GET_VIP_LOOKUP,
  payload: data,
});

export const SET_VIP_LOOKUP = 'reports-account/SET_VIP_LOOKUP';
export const setVipLookup = (data: ReadonlyArray<ReportAccountVipTable>) => {
  return {
    type: SET_VIP_LOOKUP,
    payload: data,
  };
};

export interface SetVipLookup extends Action<typeof SET_VIP_LOOKUP> {
  readonly payload: ReadonlyArray<ReportAccountVipTable>;
}
// vip report end

export const CREATE_REPORT = 'reports-account/CREATE_REPORT';
export const createReport = (data: CreateReportPayload) => ({
  type: CREATE_REPORT,
  payload: data,
});

//  report name

export const GET_REPORT_NAME = 'reports-account/GET_REPORT_NAME';
export const getReportName = (data: any) => ({
  type: GET_REPORT_NAME,
  payload: data,
});

export const SET_REPORT_NAME = 'reports-account/SET_REPORT_NAME';
export const setReportname = (data: any) => {
  return {
    type: SET_REPORT_NAME,
    payload: data,
  };
};

export interface SetReportName extends Action<typeof SET_REPORT_NAME> {
  readonly payload: any;
}

// report name end

export const EDIT_REPORT = 'reports-account/EDIT_REPORT';

export interface UpdateReportAction extends Action<typeof EDIT_REPORT>, OnCompleteAction {
  readonly payload: {
    readonly reportData: CreateReportPayload;
  };
}

export const editReport = (reportData: CreateReportPayload, onComplete?: () => void): UpdateReportAction => ({
  meta: {
    onComplete,
  },
  payload: {
    reportData,
  },
  type: EDIT_REPORT,
});

export const CLONE_REPORT = 'reports-account/CLONE_REPORT';

export interface CloneReportAction extends Action<typeof CLONE_REPORT>, OnCompleteAction {
  readonly payload: {
    readonly reportData: CreateReportPayload;
  };
}

export const cloneReport = (reportData: CreateReportPayload, onComplete?: () => void): CloneReportAction => ({
  meta: {
    onComplete,
  },
  payload: {
    reportData,
  },
  type: CLONE_REPORT,
});

export const DELETE_REPORT = 'reports-account/DELETE_REPORT';

export interface DeleteReportAction extends Action<typeof DELETE_REPORT>, OnCompleteAction {
  readonly payload: deleteReportPayload;
}

export const deleteReport = (reportData: deleteReportPayload, onComplete?: () => void): DeleteReportAction => ({
  meta: {
    onComplete,
  },
  payload: reportData,
  type: DELETE_REPORT,
});

// export const deleteReport = (data: deleteReportPayload) => ({
//   type: DELETE_REPORT,
//   payload: data
// })

export type ReportsAccountAction =
  SetDuplicateLicenseReport | SetVipLookup | SetReportName | SetAllUserNameReport | SetBulkDriverAccount;
